/* Every WhatsApp link on the site, handled in one place (round 2, #2).
 *
 * Two jobs:
 *   1. A link with no message gets the standard opening line, with the
 *      product's name when we are on a product page, so Rania does not open
 *      a chat that just says "Hi".
 *   2. Every message carries a (WEB) tag, so a website enquiry can be told
 *      apart from an ad click at a glance.
 *
 * Links that were written with a message of their own — "ask for the
 * address", "tell me when Dubai opens", the professional range's request
 * list — keep their wording and only gain the tag.
 *
 * Tapping any of them also reports Contact to the Meta pixel. fbq is put on
 * the page by the Facebook & Instagram channel; if it is not there, the link
 * still works and nothing is reported.
 *
 * It lives in its own file because theme.js and i18n-ar.js are edited by
 * other sessions, and a separate asset cannot be overwritten by one.
 */
(function () {
  'use strict';

  var TAG = '(WEB)';
  var ar = (document.documentElement.lang || '').slice(0, 2) === 'ar';

  function subject() {
    if (document.body.classList.contains('template-product')) {
      var h = document.querySelector('.product-info h1') || document.querySelector('h1');
      if (h && h.textContent.trim()) return h.textContent.trim();
    }
    return ar ? 'منتجاتكم' : 'your products';
  }

  function opening() {
    return ar
      ? 'مرحبا، بدي استفسر عن ' + subject() + ' ' + TAG
      : 'Hello, I would like to ask about ' + subject() + ' ' + TAG;
  }

  function fill(a) {
    var href = a.getAttribute('href') || '';
    if (href.indexOf('wa.me') === -1) return;

    var hash = href.indexOf('#');
    var frag = hash === -1 ? '' : href.slice(hash);
    if (hash !== -1) href = href.slice(0, hash);

    var cut = href.indexOf('text=');
    if (cut === -1) {
      a.setAttribute('href',
        href + (href.indexOf('?') === -1 ? '?' : '&') +
        'text=' + encodeURIComponent(opening()) + frag);
      return;
    }

    /* Already has a message. Add the tag once, and leave the wording alone. */
    var head = href.slice(0, cut + 5);
    var rest = href.slice(cut + 5);
    var amp = rest.indexOf('&');
    var tail = amp === -1 ? '' : rest.slice(amp);
    var msg;
    try { msg = decodeURIComponent((amp === -1 ? rest : rest.slice(0, amp)).replace(/\+/g, ' ')); }
    catch (e) { return; }                       /* malformed: leave it be */
    if (msg.indexOf(TAG) > -1) return;
    a.setAttribute('href', head + encodeURIComponent(msg + ' ' + TAG) + tail + frag);
  }

  function fillAll() {
    [].forEach.call(document.querySelectorAll('a[href*="wa.me"]'), fill);
  }

  /* Capture, so the href is right before the browser follows it — which also
     covers links the cart drawer and the search panel write after load. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me"]');
    if (!a) return;
    fill(a);
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Contact');
    } catch (x) {}
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll);
  } else {
    fillAll();
  }
})();
